import { DataType, SortDirection } from "ka-table";
import { Column } from "ka-table/models";
import { useNavigate } from "react-router-dom";
import CrmTable from "../../../App/Components/Table/CrmTable";
import { CampaignActionDictionary, ICampaign } from "../../../App/Typings/Campaigns";
import { ITablePagination } from "../../../App/Typings/SortableTable";
import { getDisplayDuration } from "../../../CampaignProfile/Components/CampaignDetails";
import { getCampaignStatus } from "../../State/ManageCampaignsState";
import { CampaignChip, CampaignMenu } from "./DisplayCampaignList";

const columns: Column[] = [
  {
    key: "name",
    title: "Name",
  },
  {
    key: "type",
    title: "Type",
    isSortable: false,
  },
  {
    key: "count",
    title: "Captures",
  },
  {
    key: "status",
    title: "Status",
    isSortable: false,
  },
  {
    key: "duration",
    title: "Duration",
    isSortable: false,
  },
  {
    key: "lastSubmissionDate",
    title: "Last Submission Date",
    dataType: DataType.Date,
  },
  {
    key: "createdDate",
    title: "Created Date",
    dataType: DataType.Date,
  },
  {
    key: "creatorNickname",
    title: "Created By",
    isSortable: false,
  },
  {
    key: "lastUpdated",
    title: "Last Updated",
    dataType: DataType.Date,
  },
  {
    key: "lastUpdatedNickname",
    title: "Last Updated By",
    isSortable: false,
  },
  {
    key: "actions",
    title: "Actions",
    isSortable: false,
    isEditable: false,
    isResizable: false,
  },
];

export default function DisplayCampaignTable({
  isLoading,
  campaigns,
  pagination,
  actions,
  sort,
  sortBy,
  onSort,
}: {
  isLoading: boolean;
  campaigns: ICampaign[];
  pagination: ITablePagination;
  actions: CampaignActionDictionary;
  sort: "asc" | "desc";
  sortBy: string;
  onSort: (prop: string) => void;
}) {
  const navigate = useNavigate();

  const data = campaigns.map((c) => {
    const campaignStatus = getCampaignStatus(c);

    return {
      ...c,
      status: campaignStatus,
      type: <CampaignChip campaign={c} />,
      actions: <CampaignMenu campaign={c} actions={actions} />,
      count: c.responseCount,
      lastUpdated: c.lastUpdatedDate,
      duration: getDisplayDuration(c),
    };
  });

  const columnsWithDefaultSort = columns.map((column) => {
    if (column.key.toLowerCase() === sortBy.toLowerCase()) {
      return { ...column, sortDirection: sort === "desc" ? SortDirection.Descend : SortDirection.Ascend };
    }
    return column;
  });

  return (
    <CrmTable
      columns={columnsWithDefaultSort}
      data={data}
      loading={isLoading}
      name="campaigns"
      pagination={pagination}
      onRowClick={(row) => {
        navigate(`/leadcapture/forms/${row.id}`);
      }}
      onSort={onSort}
      order={sort}
      orderBy={sortBy}
      rowTestId={(row) => `group-row-${row.id}`}
    />
  );
}
